// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"93":"61179f5e","182":"aa23fab4","197":"b61cd7bc","631":"4c844ba4","815":"28c533ca","878":"4c98b98d","918":"2a4e4452"}[chunkId] + ".chunk.js";
};